import { useEffect } from 'react'
import type { ISoundPlayer } from '@/features/scanner/alerts/audio/sound-player'
import { useAlertWindowSoundStore } from './alert-window-sound-store'

/**
 * Mounted once in AppLayout behind REALTIME_WEBSOCKET_ENABLED: hands the app's unlocked
 * sound player to the Alert Window panels, which ping on their own fires.
 */
export function AlertWindowNotifier({ sound }: { sound: ISoundPlayer }) {
  useEffect(() => {
    useAlertWindowSoundStore.getState().setPlayer(sound)
    return () => useAlertWindowSoundStore.getState().setPlayer(null)
  }, [sound])
  return null
}
